import {Injectable} from '@angular/core';
import {LokijsService} from './database/lokijs.service';
import {DocumentModel} from '../models/document.model';
import {CollectionsNames} from '../definitions/collections-names';

@Injectable({
    providedIn: 'root'
})
export class FindLiveConsumableLinesService {

    constructor(private loki: LokijsService,
                private collNames: CollectionsNames) {
    }

    async checkDoc(doc: DocumentModel) {
        const contracts = [];
        for (const line of doc.detailLines) {
            if (!contracts.includes(line.documentNumber)) {
                contracts.push(line.documentNumber);
            }
        }
        return this.loki.getCollection(this.collNames.LIVEDETAILLINES).chain()
            .find({$and: [{plu: {$ne: null}}, {custId: doc.customer.id}, {documentNumber: {$in: contracts}}]}).data();
    }
}
